import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getHeaders() {
  const token = sessionStorage.getItem('selecto_token');
  return { Authorization: `Bearer ${token}` };
}

export const api = {
  get: (path) => axios.get(`${API}${path}`, { headers: getHeaders() }).then(r => r.data),
  post: (path, data) => axios.post(`${API}${path}`, data, { headers: getHeaders() }).then(r => r.data),
  put: (path, data) => axios.put(`${API}${path}`, data, { headers: getHeaders() }).then(r => r.data),
  del: (path) => axios.delete(`${API}${path}`, { headers: getHeaders() }).then(r => r.data),
  delete: (path) => axios.delete(`${API}${path}`, { headers: getHeaders() }).then(r => r.data),
};
